import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import moment from 'moment';
import { IsFrequencySchedulerService } from './is-frequency-scheduler.service';

@Component({
  selector: 'is-frequency-scheduler',
  templateUrl: './is-frequency-scheduler.component.html',
  styleUrls: ['./is-frequency-scheduler.component.scss']
})
export class IsFrequencySchedulerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() chipFrequenciesChoice: boolean = false;
  @Input() listFrequencies: string[] = ['Yearly', 'Monthly', 'Weekly', 'Daily', 'Hourly'];
  @Input() labelsTranslations: string[] = ['SCHEDULER.FreqLabel', 'SCHEDULER.MonthLabel', 'SCHEDULER.WeekDayLabel', 'SCHEDULER.DayLabel', 'SCHEDULER.HourLabel', 'SCHEDULER.MinuteLabel'];
  @Input() disableAll: boolean = false;
  @Input() theme: string = '#F87595';
  @Input() appearance: string = 'fill';

  public listMonth = moment.months();
  public listWeekDays = moment.weekdays(true);
  public listNumberDays: number[] = Array.from({ length: 31 }, (_, index) => index + 1);
  public listMinute: number[] = Array.from({ length: 60 }, (_, index) => index);

  public showSelect: any = {
    month: false,
    weekDay: false,
    day: false,
    hours: false,
    minute: false
  };

  constructor(
    public _freqScheduler: IsFrequencySchedulerService
  ) { }

  ngOnInit(): void {
    this.changeFrequency(this._freqScheduler.schedulerForm.get('frequencyControl').value, false);

    this._freqScheduler.schedulerForm.get('frequencyControl').valueChanges.subscribe((newFreq) => {
      if (newFreq) {
        this.changeFrequency(newFreq, false);
      }
    });
  }

  ngOnChanges(changeEvent): void {
    if (changeEvent.disableAll?.currentValue == true) {
      this._freqScheduler.schedulerForm.disable();
    } else {
      this._freqScheduler.schedulerForm.enable();
    }
  }

  ngOnDestroy(): void {
    this._freqScheduler.schedulerForm.reset();
  }

  public changeFrequency(newFreq: string, reset: boolean): void {
    if (reset) {
      this._freqScheduler.schedulerForm.get('monthControl').reset();
      this._freqScheduler.schedulerForm.get('weekDayControl').reset();
      this._freqScheduler.schedulerForm.get('dayControl').reset();
      this._freqScheduler.schedulerForm.get('hourControl').reset();
      this._freqScheduler.schedulerForm.get('minuteControl').reset();
    }
    if (this.chipFrequenciesChoice) {
      this._freqScheduler.schedulerForm.patchValue({ frequencyControl: newFreq }, { emitEvent: false });
    }

    switch (newFreq) {
      case 'Yearly':
        this.showSelect = {
          month: true,
          weekDay: false,
          day: true,
          hours: true,
          minute: false
        };
        break;
      case 'Monthly':
        this.showSelect = {
          month: false,
          weekDay: false,
          day: true,
          hours: true,
          minute: false
        };
        break;
      case 'Weekly':
        this.showSelect = {
          month: false,
          weekDay: true,
          day: false,
          hours: true,
          minute: false
        };
        break;
      case 'Daily':
        this.showSelect = {
          month: false,
          weekDay: false,
          day: false,
          hours: true,
          minute: false
        };
        break;
      case 'Hourly':
        this.showSelect = {
          month: false,
          weekDay: false,
          day: false,
          hours: false,
          minute: true
        };
        break;
      default:
        this.showSelect = {
          month: false,
          weekDay: false,
          day: false,
          hours: false,
          minute: false
        };
        break;
    }
  }

  public formatMonth(value): number {
    return +moment().month(value).format('M');
  }

  public chipColorChange(freq: string): string {
    if (freq == this._freqScheduler.schedulerForm.get('frequencyControl').value) {
      return 'scheduler-chip-selected';
    } else {
      return 'scheduler-chip--not-selected';
    }
  }

  public selectionChange(month?: string): void {
    if (month == 'month') {
      const selectedMonth = this._freqScheduler.schedulerForm.get('monthControl').value;
      if (selectedMonth == 2) {
        this.listNumberDays = Array.from({ length: 28 }, (_, index) => index + 1);
      } else {
        const time = moment(new Date(2022, selectedMonth - 1));
        this.listNumberDays = Array.from({ length: time.daysInMonth() }, (_, index) => index + 1);
      }
    }
    this._freqScheduler.checkForm(this.showSelect);
  }
}
